export default class Discord {
    public static avatarSourceUri(userId: number | string, userAvatar: string) {
        return `https://cdn.discordapp.com/avatars/${userId}/${userAvatar}?size=128`;
    }
}
